export const closeMobileMenu = function (target) {
  const nav = document.getElementById(target);
  if (!nav) return;

  if (nav.className.indexOf('nav--active') > -1) {
    nav.classList.remove('nav--active');
    return;
  }
};

const toggle = function (event, target) {
  if (event) event.preventDefault();

  const nav = document.getElementById(target);
  if (!nav) return;

  if (nav.className.indexOf('nav--active') > -1) {
    nav.classList.remove('nav--active');
    return;
  }

  nav.classList.add('nav--active');
};

export const navigation = function () {
  window.Solver.toggle = toggle;
};
